import styled from '@emotion/styled';

import { customPalette } from '../../styles/theme';

export const DeliveryPlanSection = styled.section`
  padding: 24px 0;
  max-width: 600px;
`;

export const SectionTitle = styled.h2`
  font-size: 24px;
  color: ${customPalette.grey.main};
  margin-bottom: 24px;
`;
